export const TIPO_INFORMES_BALANCE = (t: $TSMigrationFixMe) => [
  { value: 0, label: `${t("informes.balance.header.resultLabel")}` },
  { value: 1, label: `${t("informes.balance.header.titleLabel")}` },
  { value: 2, label: `${t("informes.balance.header.groupLabel")}` },
  { value: 3, label: `${t("informes.balance.header.subGroupLabel")}` },
  { value: 4, label: `${t("informes.balance.header.accountLabel")}` },
  { value: 5, label: `${t("informes.balance.header.subAccountLabel")}` },
]

export const DATA_KEYS_BALANCE = {
  "-1": {
    className:
      "tw-text-left tw-font-medium tw-text-lg tw-border-neutral-25 tw-border-t-2 tw-pl-8",
    rowClassName:
      "tw-border-t-2 tw-border-neutral-25 [&>td]:tw-text-base [&>td]:tw-font-medium [&>td]:tw-pt-4",
    rowNumberClassName: "tw-text-lg tw-font-medium tw-px-3 tw-py-3",
  },
  0: {
    className: "tw-text-left tw-font-medium tw-text-lg tw-py-3 tw-pl-8",
  },
  1: {
    className:
      "tw-text-left tw-font-medium tw-text-lg tw-border-neutral-25 tw-border-b-2 tw-pl-8",
    rowClassName: "tw-border-b-2 tw-border-neutral-25 [&>td]:tw-font-medium",
    rowNumberClassName: "tw-text-lg tw-font-medium tw-px-3 tw-py-3",
  },
  2: {
    className: "tw-text-left tw-font-medium tw-text-base tw-pl-8",
    rowClassName:
      "tw-border-b tw-border-neutral-25 tw-border-dashed [&>td]:tw-font-medium",
    rowNumberClassName: "tw-text-base tw-font-medium tw-px-3 tw-py-3",
  },
  3: {
    className: "tw-text-left tw-font-medium tw-text-sm tw-pl-10",
    rowClassName: "",
    rowNumberClassName: "tw-text-sm tw-font-medium tw-px-3 tw-py-3",
  },
  4: {
    className: "tw-text-left tw-font-medium tw-text-sm tw-pl-12",
    rowNumberClassName: "tw-text-sm tw-font-medium tw-px-3 tw-py-3",
  },
  5: {
    className:
      "tw-text-left tw-text-sm tw-pl-14 tw-font-normal [&>div]:tw-gap-2 [&>div]:tw-flex [&>div]:tw-items-center [&>div>.status-icon]:tw-px-1 [&>div>span:nth-child(2)]:tw-inline-block  [&>div>span:nth-child(2)]:tw-whitespace-normal [&>div>span]:tw-break-words",
    rowNumberClassName: "tw-text-sm tw-font-normal tw-px-3 tw-py-3",
  },
}
